import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";
import { useMultiadapterCredentials } from "@/hooks/useMultiadapterCredentials";
import { Loading } from "@/components/ui/loading";
import { ControlWrapper } from "@/components/ui/control-wrapper";

export function MultiadapterCredentialsInput() {
  const {
    username,
    password,
    apiUrl,
    isLoading,
    showPassword,
    handleUsernameChange,
    handlePasswordChange,
    handleApiUrlChange,
    togglePasswordVisibility,
    handleSaveCredentials,
  } = useMultiadapterCredentials();

  return (
    <div className="space-y-4">
      <ControlWrapper>
        <div className="flex items-center justify-between">
          <Label htmlFor="multiadapter-username">Benutzername</Label>
        </div>
        <Input
          id="multiadapter-username"
          type="text"
          value={username}
          onChange={handleUsernameChange}
          disabled={isLoading}
          placeholder="z.B. avatarki"
        />
      </ControlWrapper>

      <ControlWrapper>
        <div className="flex items-center justify-between">
          <Label htmlFor="multiadapter-password">Passwort</Label>
        </div>
        <form
          onSubmit={e => {
            e.preventDefault();
            handleSaveCredentials();
          }}
        >
          <div className="flex gap-2">
            <Input
              id="multiadapter-password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={handlePasswordChange}
              disabled={isLoading}
              placeholder="API Passwort"
              className="flex-1"
            />
            <Button
              type="button"
              onClick={togglePasswordVisibility}
              variant="ghost"
              size="icon"
              disabled={isLoading}
            >
              {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </Button>
          </div>
        </form>
        {isLoading && <Loading />}
      </ControlWrapper>

      <ControlWrapper>
        <div className="flex items-center justify-between">
          <Label htmlFor="multiadapter-api-url">API Base URL (optional)</Label>
        </div>
        <Input
          id="multiadapter-api-url"
          type="text"
          value={apiUrl}
          onChange={handleApiUrlChange}
          disabled={isLoading}
          placeholder="https://your-api-endpoint.example.com/sprachbot"
        />
        <p className="text-xs text-muted-foreground mt-1">
          Base URL mit /sprachbot, aber ohne Endpoint-Pfad (z.B. ohne /api/v1 oder /avatarki)
        </p>
      </ControlWrapper>
    </div>
  );
}
